export const HOME_TRUSTED_SECTION = {
  label: "TRUSTED EDUCATION SYSTEM",
  titleLines: [
    "수강 · 수료 · 발급까지",
    "변화의 과정을 체계적으로 지원하는",
  ],
  headline: "재범방지 전문 교육기관",
};

export const HOME_TRUSTED_STATS = [
  {
    id: "certificates",
    label: "누적 수료증 발급",
    display: null,
    value: 12400,
    suffix: "+",
    animate: true,
  },
  {
    id: "hours",
    label: "실시간 발급 처리 시스템 운영",
    display: "24시간",
    value: null,
    suffix: "",
    animate: false,
  },
  {
    id: "lawyer",
    label: "교육 과정 운영",
    display: "변호사 협력",
    value: null,
    suffix: "",
    animate: false,
  },
];
